module.exports = [{"id":0,"val":"邪能"},{"id":1,"val":"魔法"},{"id":2,"val":"机械"},{"id":3,"val":"美食"},{"id":4,"val":"制服"},{"id":5,"val":"玩具"},{"id":6,"val":"大和"},{"id":7,"val":"黄金"},{"id":8,"val":"冰川"},{"id":9,"val":"熔岩"},{"id":10,"val":"龙"},{"id":11,"val":"源力"},{"id":12,"val":"部落"},{"id":13,"val":"世界杯"},{"id":14,"val":"深海"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/config/skin_type.json
// module id = zDQO
// module chunks = 1